import React from "react";

const BibleHistoryIcon = ({ color = "#5172EA", className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_11041_9943)">
        <path
          d="M1.56495 4.51996C1.30363 4.39021 1.19524 4.07188 1.34483 3.82139C2.08928 2.57483 3.21534 1.59418 4.56295 1.02955C6.07353 0.396635 7.76149 0.328756 9.31801 0.838331C10.8745 1.34791 12.1955 2.40086 13.0394 3.80456C13.8832 5.20826 14.1934 6.86886 13.9133 8.48253C13.6332 10.0962 12.7814 11.5551 11.5138 12.5922C10.2462 13.6294 8.64763 14.1755 7.01043 14.1306C5.37324 14.0858 3.80693 13.4529 2.59806 12.3479C1.5196 11.3621 0.789958 10.0593 0.509217 8.63479C0.452802 8.34853 0.662141 8.08536 0.951907 8.05127C1.24167 8.01718 1.50177 8.22525 1.56225 8.51067C1.81066 9.68306 2.4199 10.7536 3.31092 11.5681C4.33241 12.5018 5.65594 13.0365 7.03937 13.0745C8.4228 13.1124 9.77364 12.6509 10.8447 11.7745C11.9158 10.8981 12.6356 9.66537 12.8723 8.30181C13.109 6.93826 12.8469 5.53506 12.1338 4.34893C11.4208 3.1628 10.3045 2.27305 8.98927 1.84246C7.67402 1.41187 6.24769 1.46923 4.97125 2.00404C3.85786 2.47054 2.92344 3.2731 2.29442 4.29315C2.14128 4.5415 1.82627 4.64972 1.56495 4.51996Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.09811 1.39692C1.39532 1.39692 1.63626 1.63786 1.63626 1.93507V4.26706H3.96825C4.26546 4.26706 4.5064 4.508 4.5064 4.80522C4.5064 5.10243 4.26546 5.34337 3.96825 5.34337H1.31337C0.89727 5.34337 0.559955 5.00605 0.559955 4.58996V1.93507C0.559955 1.63786 0.800894 1.39692 1.09811 1.39692Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19716 2.47322C7.49438 2.47322 7.73532 2.71416 7.73532 3.01138V6.91619L10.9395 7.87744C11.2242 7.96284 11.3857 8.26286 11.3003 8.54753C11.2149 8.83221 10.9149 8.99376 10.6302 8.90835L6.65901 7.71699V3.01138C6.65901 2.71416 6.89995 2.47322 7.19716 2.47322Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_11041_9943">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BibleHistoryIcon;
